export const Endpoints = {
    users: '/tusers',
    categories: '/categories',
    forms: '/forms',
    reActivation: '/users/re-activation',
    lockedUsers: '/users/locked',
    applicationAuditTrail: '/applications/:id/audit-trail',
    applicationAuditTrailPdf: '/applications/:id/audit-trail/pdf',
}